<template>
  <div id="PlayMatchDiv">
    <div class="dead-player-container" v-if="player.dead">
      <h3>Game Over!</h3>
      <p>You can still stay in this game and track game progress!</p>

      <button
        class="btn btn-success btn-lg btn-block mb-5"
        v-on:click="leaveGame()"
      >
        <i class="fas fa-home mr-3"></i>Back to home screen
      </button>
    </div>

    <flip-countdown :deadline="deadline" :showDays="false" v-if="deadline" />

    <div class="form-group avatarDiv">
      <carousel
        :per-page="1"
        :mouse-drag="true"
        :navigationEnabled="true"
        paginationPosition="top"
        navigationClickTargetSize="20"
        navigationNextLabel="Next"
        navigationPrevLabel="Prev"
        :adjustableHeight="true"
        v-model="currentSlide"
        ref="carousel"
        v-on:pageChange="pageChange"
      >
        <slide
          v-for="(q, qidx) in qas"
          :key="qidx"
          :style="{ height: 'fit-content' }"
        >
          <div class="carousel__item">
            <div><img :src="'/questions/' + q.q" /></div>
            <div class="answerDiv">
              <div
                class="answer"
                v-for="(a, aidx) in answers"
                :key="aidx"
                @click="saveAnswer(qidx, a)"
                :class="{ selected: a === q.playera }"
              >
                {{ a }}
              </div>
            </div>
          </div>
        </slide>

        <template #addons>
          <navigation />
        </template>
      </carousel>
    </div>

    <div class="doneDiv" v-if="iamdone"><button class="btn btn-success done" @click="toggleIamdone()">Waiting for others to complete</button></div>
    <div class="doneDiv" v-else><button class="btn btn-danger done" @click="toggleIamdone()">Click to complete the game!</button></div>

    <div
      class="alert mt-2 fixed-bottom mx-5"
      v-on:click="hideMessage()"
      v-bind:class="{
        'alert-info': message.state === 'info',
        'alert-danger': message.state === 'danger',
        'alert-success': message.state === 'success',
        'alert-warning': message.state === 'warning',
      }"
      v-if="message.show"
      v-html="message.msg"
    ></div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import GameService from "@/services/GameService.js";
import PlayerService from "@/services/PlayerService.js";
import { Carousel, Slide } from "vue-carousel";
import FlipCountdown from "vue2-flip-countdown";

export default {
  name: "PlayingMatch",
  components: {
    Carousel,
    Slide,
    FlipCountdown,
  },
  data() {
    return {
      game: {
        playerIDs: [],
        currentEntity: {},
        questions: [],
        minutes: 0,
      },
      fields: [],
      player: {},
      gameCode: "",
      inRound: false,
      ended: false,
      sunkShips: [],
      message: {
        show: false,
        msg: "",
        state: "info",
      },
      myTurn: false,
      shooted: false,
      playerInTurn: {},
      otherPlayers: [],
      entity: {},
      reloadGameButton: false,
      firstShot: false,
      currentSlide: 0,
      answers: ["A", "B", "C", "D"],
      deadline: null,
      clientTimezoneOffset: new Date().getTimezoneOffset(),
      gameStarted: false,
      iamdone:false,
    };
  },
  computed: {
    qas() {
      return this.game.questions.map((q) => ({ q: q, playera: null }));
    },
  },

  mounted() {
    setTimeout(this.$refs.carousel.computeCarouselHeight, 1000);
  },
  async created() {
    // get gameCode for getting game
    const gameCode = this.$route.params.gameCode;
    this.gameCode = gameCode;
    try {
      GameService.getGame(gameCode).then(async (game) => {
        this.game = game;
        this.player = this.$store.state.player;
        // check user rights, states, etc.
        await this.startupCheck();

        // game already started in prior step
        /*this.$socket.emit("startGame", {
          gameCode: this.game.gameCode,
        });*/

        this.deadline = this.game.endTime;
        //console.log(this.game);

      });
    } catch (err) {
      this.$router.push({
        name: "start",
        params: {
          error: "Sorry, Something went wrong.. (Error code: #PM)",
        },
      });
    }

    // show refresh button after 10 seconds
    setTimeout(() => {
      this.reloadGameButton = true;
    }, 10000);
  },
  methods: {
    pageChange(n) {
      // eslint-disable-next-line no-console
      //console.log("current Index", n);
    },

    toggleIamdone(){

      this.iamdone = !this.iamdone;
      this.$socket.emit("togglePlayerDone", {
        gameCode: this.game.gameCode,
        playerId: this.player.id
      });

    },

    saveAnswer(idx, a) {
      this.qas[idx].playera = a;
      //console.log(this.qas);
      this.currentSlide++;
      this.$socket.emit("saveAnswer", {
        gameCode: this.game.gameCode,
        qas: this.qas,
        player: this.player,
      });
    },
    fillFields() {
      this.fields = [];
      for (let x = 0; x < this.game.fieldsize; x++) {
        for (let y = 0; y < this.game.fieldsize; y++) {
          this.fields.push({
            x,
            y,
            ship: false,
            hit: false,
            shipHit: false,
          });
        }
      }
    },
    fillOwnFields() {
      this.fillFields();

      // set own hits
      this.sunkShips = [];

      this.setHits(this.player);

      // set ships (visible)
      this.player.ships.forEach((ship) => {
        let field = this.getField(ship.x, ship.y);
        field.ship = true;
        field.end = ship.end;
        field.start = ship.start;
        field.orientation = ship.orientation;
        field.special = ship.special;
      });
    },
    setHits(player) {
      player.hits.forEach((hit) => {
        let field = this.getField(hit.x, hit.y);
        field.hit = true;

        // if hit is ship hit
        player.ships.forEach((ship) => {
          if (ship.x === hit.x && ship.y === hit.y) {
            field.shipHit = true;

            let shipHits = 0;
            player.ships.forEach((s) => {
              if (s.id === ship.id) {
                let f = this.getField(s.x, s.y);

                if (f.hit) shipHits++;
              }
            });

            // if ship is hitted completely
            if (shipHits === ship.length) {
              this.sunkShips.push({
                id: ship.id,
                length: ship.length,
              });
            }
          }
        });
      });

      // when entity field => show sunk ships
      if (player.id !== this.player.id) {
        this.showSunkShips();
      }
    },
    showSunkShips(entity) {
      // loop over all sunk ships
      this.sunkShips.filter((s) => {
        // loop all ships of entity and show sunk
        this.entity.ships.forEach((ship) => {
          if (ship.id === s.id) {
            let field = this.getField(ship.x, ship.y);
            field.ship = true;
            field.end = ship.end;
            field.start = ship.start;
            field.orientation = ship.orientation;
            field.special = ship.special;
          }
        });
      });
    },
    async shoot(x, y) {
      // check if already shoot
      if (this.shooted) {
        return false;
      }

      // check if not hitted before
      let hitted = false;
      this.entity.hits.forEach((hit) => {
        if (hit.x === x && hit.y === y) {
          hitted = true;
        }
      });
      if (hitted) {
        return false;
      }

      // set first shot
      this.firstShot = true;

      // add hit to entities field
      this.entity.hits.push({
        x,
        y,
        playerID: this.player.id,
      });

      this.shooted = true;

      let field = this.getField(x, y);
      field.hit = true;

      // loop over all ships and search for hit
      let shipHit = false;
      this.entity.ships.forEach((ship) => {
        if (ship.x === x && ship.y === y && !ship.hit) {
          ship.hit = true;
          field.shipHit = true;
          shipHit = true;
          this.shooted = false;

          // send message to entity
          this.$socket.emit("playingUpdate", {
            gameCode: this.game.gameCode,
            attacker: this.player,
            entity: this.entity,
            type: "hit",
          });

          // check if ship is completed
          let shipHits = 0;
          this.entity.ships.forEach((s) => {
            if (s.id === ship.id) {
              let field = this.getField(s.x, s.y);

              if (field.hit) shipHits++;
            }
          });

          // if ship is hitted completely
          if (shipHits === ship.length) {
            ship.sunk = true;
            this.showMessage(
              `You have a ship from <b>${this.entity.username}</b> sunk! Very good, Captain!`,
              "success"
            );

            this.sunkShips.push({
              id: ship.id,
              length: ship.length,
            });

            this.showSunkShips();

            // send message to entity
            this.$socket.emit("playingUpdate", {
              gameCode: this.game.gameCode,
              attacker: this.player,
              entity: this.entity,
              type: "sunk",
            });
          }
        }
      });

      // if player dead
      const hittedShipParts = this.entity.ships.filter((ship) => ship.hit);
      let shipPartsSunk = hittedShipParts.length;
      const allShipsDown =
        shipPartsSunk === this.entity.ships.length && shipPartsSunk > 0;
      if (allShipsDown) {
        // set to death on server
        this.entity.dead = true;
        this.entity = await PlayerService.updatePlayer(this.entity);

        this.showMessage(
          `Congratulations, soldier! The entire fleet of ${this.entity.username} is destroyed!`,
          "success"
        );

        // check if last player alive
        const alivePlayerIDs = await GameService.getAlivePlayers(
          this.game.gameCode
        );
        if (
          alivePlayerIDs.length === 1 &&
          alivePlayerIDs[0] === this.player.id
        ) {
          // tell other players
          this.$socket.emit("playingUpdate", {
            gameCode: this.game.gameCode,
            attacker: this.player,
            type: "winner",
          });

          // set winner to game
          this.game.winner = this.player;

          this.game.state = 2;
          this.game = await GameService.updateGame(this.game);

          // redirect to home screen
          setTimeout(() => {
            this.$router.push(`/match/${this.game.gameCode}/ending`);
          }, 3000);
          return false;
        }
      }

      // update entity
      this.entity = await PlayerService.updatePlayer(this.entity);

      this.$socket.emit("playingUpdate", {
        gameCode: this.game.gameCode,
        attacker: this.player,
        entity: this.entity,
        type: "updateSpectatorView",
      });

      // when no ship hit => next player
      if (!shipHit || allShipsDown) {
        this.inRound = false;
        this.$socket.emit("nextPlayer", { gameCode: this.gameCode });
      }
    },
    showChangeEntity() {
      this.entity = {};
    },
    async changeEntity(entity) {
      // show error when entity dead
      if (entity.dead) {
        this.showMessage(
          `The fleet of ${entity.username} is already destroyed.`,
          "danger"
        );
        return false;
      }

      this.entity = entity;

      // get current game to avoid update problems
      this.game = await GameService.getGame(this.game.gameCode);

      // update current game
      this.game.currentEntity = entity;

      // update game
      this.game = await GameService.updateGame(this.game);

      // fill fields with current fieldsize
      this.fillFields();

      // reset sunken ships => set new in this method
      this.sunkShips = [];

      // set hits
      this.setHits(this.entity);
    },
    async startupCheck() {
      return new Promise((resolve, reject) => {
        // if player is not in game
        if (!GameService.playerIsInGame(this.player, this.game)) {
          this.$router.push({
            name: "start",
            params: {
              error: "I don't think you're in the right place..",
            },
          });
        }
        resolve();
      });
    },
    showMessage(msg, state = "info", hide = 5) {
      this.message.msg = msg;
      this.message.state = state;
      this.message.show = true;

      clearTimeout(this.message.timeout);
      this.message.timeout = setTimeout(() => {
        this.hideMessage();
      }, hide * 1000);
    },
    hideMessage() {
      this.message.show = false;
    },
    getField(x, y) {
      return this.fields.filter((f) => f.x === x && f.y === y)[0];
    },
    reloadGame() {
      this.$socket.emit("nextPlayer", { gameCode: this.game.gameCode });
      this.showMessage("Game is reloading!", "warning");
    },
    leaveGame() {
      // remove player from game
      GameService.removePlayer(this.game.gameCode, this.player.id);

      // delete player
      PlayerService.deletePlayer(this.player.id);
      this.$store.dispatch("setPlayer", null);

      // update socket view
      this.$socket.emit("playerLeaveGame", {
        gameCode: this.game.gameCode,
        player: this.player,
      });

      // redirect to home
      this.$router.push({
        name: "start",
        params: {},
      });
    },
  },
  sockets: {
    startGame: async function (data) {
      //this.deadline = data.game.endTime;
      //this.gameStarted = true;
      //console.log(data);
    },
    nextPlayer: async function (data) {
      // if emit is for current game
      if (this.game.gameCode === data.gameCode) {
        // TODO ERROR HANDLING OR REDIRECT TO END PAGE
        if (this.ended) {
          return false;
        }

        this.game = data.game;

        // reset view data
        this.entity = {};
        this.shooted = false;
        this.firstShot = false;
        this.hideMessage();

        // get refreshed game var
        const gameCode = this.$route.params.gameCode;
        GameService.getGame(gameCode).then(async (game) => {
          this.game = game;
          this.game.currentEntity = {};
        });

        // update player obj
        this.player = await PlayerService.getPlayer(
          this.$store.state.player.id
        );

        // set new socket vars
        this.otherPlayers = data.otherPlayers;
        this.inRound = true;

        if (data.playerInTurn.id === this.player.id) {
          // own turn
          this.myTurn = true;

          // if two players => choose entity directly
          if (this.game.playerIDs.length === 2) {
            this.changeEntity(this.otherPlayers[0]);
          }
        } else {
          // others turn
          this.myTurn = false;
          this.playerInTurn = data.playerInTurn;

          // fill own field
          this.fillOwnFields();
        }
      }
    },
    playingUpdate: async function (data) {
      // if emit is for current game
      //console.log(data);
      if (this.game.gameCode === data.gameCode) {
        switch (data.type) {
          /*case "hit":
            this.showMessage(
              `<b>${data.attacker.username}</b> has a ship from <b>${data.entity.username}</b> hit!`,
              "info"
            );
            break;
          case "sunk":
            this.showMessage(
              `<b>${data.attacker.username}</b> has a ship from <b>${data.entity.username}</b> sunk!`,
              "info"
            );
            break;
          case "playerDead":
            this.showMessage(
              `<b>${data.attacker.username}</b> has the complete fleet of <b>${data.entity.username}</b> destroyed!`,
              "success"
            );
            break;
          case "updateSpectatorView":
            // update only when entity player
            if (this.player.id === data.entity.id) {
              this.player = await PlayerService.getPlayer(this.player.id);

              this.fillOwnFields();
            }
            break;*/
          case "winner":
            //console.log("here winner");
            this.ended = true;
            this.showMessage("Time is up. Preparing the results...", "success");

            setTimeout(() => {
              this.$router.push(`/match/${this.game.gameCode}/ending`);
            }, 3000);
            break;

          case "winnerAllPlayersDone":
            //console.log("here winner");
            this.ended = true;
            this.showMessage("All players have completed the game. Preparing the results...", "success");

            setTimeout(() => {
              this.$router.push(`/match/${this.game.gameCode}/ending`);
            }, 3000);
            break;
        }
      }
    },
    saveAnswers: async function (game) {
      // if emit is for current game
      if (this.game.gameCode === game.gameCode) {
      }
    },


  },
};
</script>

<style scoped>
.ship-info-container {
  padding: 1rem 2rem;
  border-radius: 15px;
  background-color: rgba(255, 255, 255, 0.5);
  width: 560px;
  margin: 0 auto;
}
.ship-info-container .ship {
  display: flex;
  margin: 0.5rem 0;
}
.ship-info-container .ship > div {
  height: 40px;
  width: 40px;
  padding: 0;
  border: 2px solid #08628a;
  margin: 1px;
}
.ship-info-container .ship.completed > div {
  background-color: #08628a;
}
.answerDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
.answer {
  width: 50px;
  height: 50px;
  font-size: 30px;
  border: 1px solid #d3d1d1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}
.VueCarousel-slide-adjustableHeight {
  display: block !important;
}
.VueCarousel-inner {
  align-items: flex-start !important;
}
.VueCarousel-navigation-button:hover {
  background-color: #c4c1c1;
  cursor: pointer;
}
.answer.selected {
  background-color: #0482c5;
  color: #ffffff;
}
.doneDiv{
  margin:40px;
}
</style>
